import { motion, AnimatePresence } from "motion/react";
import { useVideoSettings } from "../../contexts/videoSettings/videoSettings.hook";
import { usePhone } from "../../contexts/phone/phone.hook";
import { usePrefersReducedMotion } from "../../contexts/prefersReducedMotion/prefersReducedMotion.hook";
import styles from "./Homepage.module.scss";
import useResponsive from "../../hooks/useResponsive";

export default function Homepage({ children }) {
  const { isPlayingIntroVideo } = useVideoSettings();
  const { isPhoneOpen, setIsPhoneOpen } = usePhone();
  const { prefersReducedMotion } = usePrefersReducedMotion();
  const { isMobile } = useResponsive();

  const contentVariants = {
    hidden: prefersReducedMotion
      ? { y: 0, opacity: 1 }
      : { y: -100, opacity: 0 },
    visible: { y: 0, opacity: 1 },
  };

  return (
    <AnimatePresence mode="popLayout">
      {!isPlayingIntroVideo && (
        <motion.div
          key="content"
          animate={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          transition={{ duration: 1 }}
          className={styles.videoWrapper}
        >
          {prefersReducedMotion || isMobile ? (
            <picture className={styles.backgroundAsset}>
              <source
                srcSet="/SH_HEADER_STILL_1080X1920.png"
                media="(max-width: 767px)"
              />
              <img
                src="/SH_HEADER_STILL_2560X1440.png"
                alt=""
                className={styles.backgroundAsset}
              />
            </picture>
          ) : (
            <video
              autoPlay
              playsInline
              muted
              loop
              className={styles.backgroundAsset}
            >
              <source
                src="/SH_HEADER_VIDEO_1080X1920.mp4"
                type="video/mp4"
                media="(max-width: 767px)"
              />
              <source src="/SH_HEADER_VIDEO_2560X1440.mp4" type="video/mp4" />
            </video>
          )}

          <div className={styles.darkRedOverlay} />

          <AnimatePresence>
            {!isPhoneOpen && (
              <motion.div
                className={styles.contentWrapper}
                key="text"
                initial="hidden"
                animate="visible"
                exit="hidden"
                transition={{ type: "tween", duration: 0.1 }}
                variants={contentVariants}
              >
                <h1
                  className={styles.pageTitle}
                  aria-label="Skillhouse in theaters July 11"
                >
                  In theaters
                  <span className="anotherDanger">July II</span>
                </h1>
                <p>What would you do for clout?</p>
                <button
                  onClick={() => setIsPhoneOpen(true)}
                  className={styles.phoneTriggerButton}
                >
                  Post or&nbsp;&nbsp;
                  <span className="anotherDanger">Die</span>
                </button>
              </motion.div>
            )}
          </AnimatePresence>

          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
